import { Injectable, inject } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { Slug } from '../api/common-models';
import { SlugApiService } from '../api/slug/slug-api.service';
import { Slugger } from '../api/slug/slug-models';
import { LocalStorageService } from '../storage/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class SlugManagerService {
  private readonly slugService = inject(SlugApiService);
  private readonly localStorageService = inject(LocalStorageService);

  public static readonly SIRCLE_TYPE: string = 'SIRCLE';
  public static readonly MEMBER_TYPE: string = 'MEMBER';

  async loadSlugger(): Promise<Slugger> {
    const slugger = await firstValueFrom(this.slugService.getSlugger());
    this.localStorageService.setSlugger(slugger);
    return slugger;
  }

  private retrieveSluggerSafe(): Slugger {
    const STORED: Slugger = this.localStorageService.getSlugger();
    if (STORED !== undefined && STORED !== null) {
      return STORED;
    } else {
      this.loadSlugger().then(function (result) {
        return result;
      });
    }
  }

  private getSlugByType(type: string): Slug[] {
    let SLUGGER: Slug[] = undefined;
    switch (type) {
      case 'SIRCLE': {
        SLUGGER = this.retrieveSluggerSafe().SIRCLE;
        break;
      }
      case 'MEMBER': {
        SLUGGER = this.retrieveSluggerSafe().MEMBER;
        break;
      }
      default: {
        SLUGGER = undefined;
        break;
      }
    }
    return SLUGGER;
  }

  public getIdFromSlugger(type: string, slug: string): number {
    const SLUGGER: Slug[] = this.getSlugByType(type);
    return SLUGGER?.find((slugger) => slugger.slugName === slug)?.id;
  }

  private cleanSlugger(id: number, slugs: Slug[]): Slug[] {
    const INDEX = slugs.findIndex((item) => item.id === id);
    // findIndex returns -1 when the id is absent, and splice(-1, 1) would drop
    // the last entry instead of doing nothing
    if (INDEX !== -1) {
      slugs.splice(INDEX, 1);
    }
    return slugs;
  }

  public addSlugToSlugger(type: string, slug: Slug): void {
    const SLUGGER: Slugger = this.retrieveSluggerSafe();
    switch (type) {
      case 'SIRCLE': {
        this.cleanSlugger(slug.id, SLUGGER.SIRCLE);
        SLUGGER.SIRCLE.push(slug);
        break;
      }
      case 'MEMBER': {
        this.cleanSlugger(slug.id, SLUGGER.MEMBER);
        SLUGGER.MEMBER.push(slug);
        break;
      }
      default: {
        break;
      }
    }
    this.localStorageService.setSlugger(SLUGGER);
  }

  public delSlugFromSlugger(type: string, id: number): void {
    const SLUGGER: Slugger = this.localStorageService.getSlugger();
    switch (type) {
      case 'SIRCLE': {
        this.cleanSlugger(id, SLUGGER.SIRCLE);
        break;
      }
      case 'MEMBER': {
        this.cleanSlugger(id, SLUGGER.MEMBER);
        break;
      }
      default: {
        break;
      }
    }
    this.localStorageService.setSlugger(SLUGGER);
  }
}
